import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import Logo from '../assets/logo.png';
import Dashboard from '../assets/icons/Dashboard_24px.png';
import Campaign from '../assets/icons/Campaign_24px.png';
import ShortListed from '../assets/icons/Shortlist_24px.png';
import ActivityLogSvg from '../assets/icons/ActivityLog_24px.png';
import userAvtar from '../assets/icons/Avatar.png';
import MobileMenu from '../assets/icons/More_24px.svg';
import Close from '../assets/icons/Close_24px.png';
import '../styles/SideMenuMobileView.css';
import { useAuth } from '../contexts/AuthContext';
import UserProfileDropdown from './UserProfileDropdown';
import AIBot from '../assets/icons/ai-chatting.svg'

const SideDrawerMobileView = ({ isAdmin }) => {
  const { userRole, username } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const menuItems = [
    { path: '/dashboard', icon: Dashboard, label: 'Dashboard' },
    { path: '/campaigns', icon: Campaign, label: 'Campaign' },
    { path: '/shortlisted', icon: ShortListed, label: 'Shortlisted' },
    {
      path: '/support',
      icon: AIBot,
      label: 'SocialJet GPT',
    },
  ];

  if (userRole === 'Administrator') {
    menuItems.push({ path: '/activitylog', icon: ActivityLogSvg, label: 'Activity Log' });
  }

  return (
    <>
      {/* Top Header */}
      <div className="menu-header">
        <NavLink to="/" className="logo-wrapper" aria-label="Site Logo">
          <img src={Logo} alt="Menu Logo" className="logo-large-mobile" />
        </NavLink>


        <div>
          <div className='d-flex align-items-center'>
        <button className="menu-btn me-3" onClick={() => setOpen(true)}>
          <img src={MobileMenu} alt="Open Menu" />
        </button>
          <UserProfileDropdown/>
          </div>
        </div>
      </div>

      <hr className='m-0'/>

      {/* Backdrop */}
      {open && <div className="backdrop" onClick={() => setOpen(false)} />}

      {/* Side Drawer */}
      <div className={`drawer ${open ? 'open' : ''}`}>
        <div className="menu-header-mobile">
          <h3 className="menu-title">Menu</h3>
          <button className="close-btn" onClick={() => setOpen(false)}>
            <img src={Close} alt="Close Menu" className="close-icon" />
          </button>
        </div>

        {/* Navigation Links */}
        <div className="menu-content-mobile">
          <Nav className="menu-nav">
            {menuItems.map(({ path, icon, label }) => (
              <Nav.Link
                as={NavLink}
                to={path}
                key={path}
                eventKey={path}
                onClick={() => setOpen(false)} // Close drawer on navigation
                className={`menu-item ${location.pathname === path ? 'active' : ''}`}
              >
                <img src={icon} alt={`${label} Icon`} className="menu-icon" />
                <span className="menu-text">{label}</span>
              </Nav.Link>
            ))}
          </Nav>
        </div>

        {/* User Info */}
        <div className="user-profile-mobile">
          <img src={userAvtar} alt="User Avatar" className="user-avatar" />
          <div className="user-details">
            <p className="user-name">{username}</p>
            <p className="user-role">{userRole}</p>
          </div>
          <span className="user-menu">⋮</span>
        </div>
      </div>
    </>
  );
};

export default SideDrawerMobileView;
